import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import banner from "../otherImages/sigupbanner.png";
import logo from "../otherImages/black-logo-icon.png";
import { Formik, Form, Field } from "formik";
import { loginUser } from "../Redux/Reducers/AuthSlice";

const SignInLayer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth || { loading: false, error: null });

  const handleLogin = async (values, { setSubmitting }) => {
    const { email, password } = values;

    try {
      const result = await dispatch(loginUser({ email, password })).unwrap();
      const accessToken = result?.data?.access_token || result?.data?.token;
      if (accessToken) {
        localStorage.setItem("access_token", accessToken);
        navigate("/users");
      } else {
        alert("Login failed: No token received");
      }
    } catch (error) {
      const errorMessage = error?.message || "Invalid email or password";
      alert(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className='auth bg-base d-flex'>
      <div className='auth-left d-lg-block d-none'>
        <div className='d-flex align-items-center flex-column h-100 justify-content-center'>
          <img className="h-100vh w-100" src={banner} alt='' style={{ objectFit: "cover", objectPosition: "top" }} />
        </div>
      </div>
      <div className='auth-right d-flex flex-column justify-content-center'>
        <div className='text-center'>
          <img src={logo} alt='' />
        </div>
        <div className="box">
          <h4 className='mb-12 fw-bold'>Login to Your Account</h4>
          
          {error && (
            <div className="alert alert-danger mb-3" role="alert">
              {typeof error === 'string' ? error : error?.message || 'Login failed. Please try again.'}
            </div>
          )}
          
          <Formik
            initialValues={{ email: "", password: "" }}
            onSubmit={handleLogin}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className='icon-field mb-16'>
                  <label className="black">Email Address</label>
                  <Field
                    type='email'
                    name='email'
                    className='form-control h-56-px bg-neutral-50 radius-12'
                    placeholder='Email'
                    required
                  />
                </div>

                <div className='position-relative mb-20'>
                  <div className='icon-field'>
                    <label className="black">Password</label>
                    <Field
                      type='password'
                      name='password'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      placeholder='Password'
                      required
                    />
                  </div>
                </div>

                <button 
                  type='submit' 
                  className='btn bg-black py-16 w-100 radius-12 mt-32 white'
                  disabled={loading || isSubmitting}
                >
                  {loading || isSubmitting ? 'Logging in...' : 'Login In'}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;